// 定义文件别名对象
// 在引入的时候就可以使用 import {LayoutHeader, LayoutCenter} from '~/views/layouts'
export { default as LayoutHeader } from './LayoutHeader.vue'
export { default as LayoutCenter } from './LayoutCenter.vue'
export { default as LayoutLeft } from './LayoutLeft.vue'
export { default as LayoutFooter } from './LayoutFooter.vue'


// WEBPACK FOOTER //
// ./src/views/layouts/index.js